// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDKTjO_-bRTqXUxguiqN3AZeH_pChf4PNo",
  authDomain: "wooju-68acf.firebaseapp.com",
  projectId: "wooju-68acf",
  storageBucket: "wooju-68acf.firebasestorage.app",
  messagingSenderId: "1062822057963",
  appId: "1:1062822057963:web:f4118fee2e755162bcabae",
  measurementId: "G-VJ9T3ETVRN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth with persistent storage
export const auth = getAuth(app);

// Set persistence to LOCAL so anonymous users keep their UID across sessions
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Error setting auth persistence:', error);
});

// Initialize Firestore with the specific database for mobile app
export const db = getFirestore(app, "sept-android-noauth");
export const functions = getFunctions(app, "us-central1");

export default app;
